import CarBrand from './CarBrand';

export default CarBrand;